//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    music: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['getMusicData']),
    ...mapMutations(['setLoad', 'setToast', 'setMiniPlayer']),
    async playMusic(music) {
      this.setLoad(true)
      try {
        let res = await this.getMusicData(music)
        this.$store.state.playerStatus = true
        this.setMiniPlayer(false)
        this.$router.push({
          path: '/player',
        })
      } catch (err) {
        this.setToast(true)
      } finally {
        this.setLoad(false)
      }
    },
  },
}
